import { createStyles, makeStyles, Theme } from '@material-ui/core/styles';
import React from 'react';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      display: 'flex',
      flexWrap: 'wrap',
      margin: '0 -4px',
      '& > *': {
        margin: theme.spacing(0.5)
      },
    }
  })
);

interface Props {
  children: React.ReactNode;
}

function ChipContainer(props: Props) {
  const classes = useStyles({});
  return (
    <div className={classes.root}>
      {props.children}
    </div>
  );
};

export default ChipContainer;
